import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const ViewCartSkeletonWrapper = styled.div({
	margin: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "2px"
});

export const CartSkeletonCard = styled(Card)({
	borderRadius: "unset"
});

export const CartSkeletonTotalCard = styled(Card)(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.info,
	color: theme.project.colors.fontColors.main,
	padding: "0 32px",
	borderRadius: "unset",
	marginBottom: "1px",
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center"
}));
